import { useState, useEffect } from "react";
import type { ReactElement, SVGProps } from "react";
import { FaSearch } from "react-icons/fa";

type SearchBarProps = {
  setResults?: (results: any[] | undefined) => void;
  getResult?: (value: boolean) => void;
};

const SearchIcon = FaSearch as unknown as (props: SVGProps<SVGSVGElement>) => ReactElement;

const SearchBar = ({ setResults, getResult }: SearchBarProps) => {
  const [input, setInput] = useState("");
  const [nodes, setNodes] = useState<any[]>([]);
  const [getBool, setBool] = useState(true);
  useEffect(() => {
    getNodes();
  }, []);

  const getNodes = async () => {

    try {

      const response = await fetch('http://127.0.0.1:5000/getNodes', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },

      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      const dataArray = Array.isArray(result) ? result : (result?.data ?? []);
      console.log('Success:', result);
      setNodes(dataArray)

    } catch (error) {
      console.error('Error sending data:', error);

    }
  }

  const fetchData = (value) => {

    const results = nodes.filter((node) => {
      return (
        value &&
        node &&
        node.name &&
        node.name.toLowerCase().includes(value.toLowerCase())
      );
    });
    console.log("RESULTS", results)
    if (setResults) {
      setResults(results ?? []);
    }
    setBool(false);
    if (getResult) {
      getResult(getBool);
    }

  };

  const handleChange = (value) => {
    setInput(value);
    fetchData(value);
  };

  return (
    <div style={{ height: "40px" }} className="input-wrapper">

      <SearchIcon id="search-icon" />
      <input
        placeholder="Type to search..."
        value={input}
        onChange={(e) => handleChange(e.target.value)}
      />
    </div>
  );
};

export default SearchBar;
